export function getFormattedDate(date){
  const originalDate = new Date(date)
  return originalDate.toLocaleString('de-DE', {month: '2-digit', day: '2-digit', year: 'numeric'})
}
